import { render, staticRenderFns } from "./PurchaseAggregation.vue?vue&type=template&id=a61c62b0&"
import script from "./PurchaseAggregation.vue?vue&type=script&lang=js&"
export * from "./PurchaseAggregation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports